import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ChampRD_Type } from 'src/app/models/champD.type';
import { GeneralService } from 'src/app/services/general.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-simed-article',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.scss']
})
export class SimedArticleComponent implements OnInit {

  articleDS: any = {};
  articleFormGroup: FormGroup;

  ChampRD_Type = ChampRD_Type;

  formGroup: FormGroup;
  propNames = [];

  api = environment.apiEndPoint;
  ds;

  options = { placeholder: 'AE' };

  constructor(
    private fb: FormBuilder,
    private generalService: GeneralService
  ) { }

  ngOnInit(): void {
    this.getDS();
  }

  getDS() {
    this.generalService.getDS('Article')
      .subscribe((ds: any) => {
        this.articleDS = ds;
        this.buildFormGroup(ds.Art[0]);
      });
  }

  buildFormGroup(item) {
    if (!this.formGroup) {
      this.getStructure();
    }
    else {
      this.setValues(item);
    }
  }

  getStructure() {
    this.generalService.tbRecherche("Article")
      .subscribe((res: any) => {
        this.formGroup = this.fb.group({});
        let structure = res.TableRD;
        structure = structure.sort((n1, n2) => n1.TableRD_Ordre - n2.TableRD_Ordre);
        structure.forEach(element => {
          if (!this.formGroup.contains(element.TableRD_Champs)) {
            this.formGroup.addControl(element.TableRD_Champs, this.fb.control(null));
            this.propNames.push(element);
          }
        });
      });
  }
  
  setValues(item) {
    this.propNames.forEach(element => {
      if (item[element.TableRD_Champs]) {
        this.formGroup.get(element.TableRD_Champs).setValue(item[element.TableRD_Champs]);
      }
    });
  }

  handleAdd() {
    this.getDS();
  }
  handleUpdate() {
    Object.assign(this.ds.Art[0], this.formGroup.value);
    this.generalService.enregisterTable(this.ds)
      .subscribe((res) => {
        this.getDS();
      });
  }
  handleDelete() {
    Swal.fire({
      title: 'Êtes-vous sur ?',
      text: 'Ceci est irreversible.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non'
    }).then((result) => {
      if (result.value) {
        this.generalService.supprimer(this.ds.Art[0].ArtD_Id, 'Article');
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Annulé',
          'Rien n\'a été supprimé',
          'error'
        );
      }
    })
  }
  handleSelect(item) {
    this.buildFormGroup(item);
  }
  handleImprimer() { }

  save() {
    Object.assign(this.articleDS.Art[0], this.articleFormGroup.value);
    this.articleDS.Art[0].Art_GesStock = Number(this.articleDS.Art[0].Art_GesStock);
    this.generalService.enregisterTable(this.articleDS)
      .subscribe((res) => {
        this.getDS();
        this.buildFormGroup(res.Art[0]);
      });
  }

}
